import m from 'mithril'

export default {
  view: vnode => {
    const portalHeight = vnode.attrs.portalHeight

    return (
      <svg
        style={`margin-top: ${portalHeight}px;`}
        className="hotspot-portal-arrow u-hotspot-fade"
        width="540"
        height="540"
        viewBox="0 0 540 540"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          className="hotspot-portal-arrow-path"
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M270 540C419.117 540 540 419.117 540 270C540 120.883 419.117 0 270 0C120.883 0 0 120.883 0 270C0 419.117 120.883 540 270 540ZM269.777 133L340.487 203.711L446.553 309.777L375.843 380.487L269.777 274.421L163.711 380.487L93 309.777L199.066 203.711L269.777 133Z"
        />
      </svg>
    )
  }
}
